import axios from 'axios';

import PaisEditar from '../types/PaisEditar';


async function GuardarPais(prmPais: PaisEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_pais"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "pais": {
                "id": prmPais.id,
                "nombre": prmPais.pais,
                "codigo_iso": prmPais.codigo_iso,
                "codigo_tel": prmPais.codigo_tel,
                "habilitado": prmPais.habilitado,
                "fch_crea": prmPais.fch_crea,
                "fch_modi": prmPais.fch_modi,
                "dado_baja": prmPais.dado_baja,
                "fch_baja": prmPais.fch_baja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarPais;